// extracted by mini-css-extract-plugin
export default {"block":"Timer_block__5ny8c","last_dial":"Timer_last_dial__RnTiA"};